import { StateStatus } from './StateStatus';

const stateHasItems = obj => obj && obj === StateStatus.LOADED && obj.data && obj.data.length > 0;

const stateIsEmpty = obj => obj?.status === StateStatus.LOADED && !obj?.data?.length;

const stateIsLoading = obj => {
  if (Array.isArray(obj)) {
    return obj.some(x => x.status === StateStatus.LOADING);
  }
  return !obj || obj.status === StateStatus.LOADING;
};

const stateIsNotInitialized = obj => !obj || obj.status === StateStatus.NOT_INITIALIZED;

const stateIsNotReady = obj => {
  if (Array.isArray(obj)) {
    return obj.some(x => x.status <= StateStatus.LOADING || x.status === StateStatus.REFRESHING);
  }
  return !obj || obj.status <= StateStatus.LOADING || obj.status === StateStatus.REFRESHING;
};

const stateIsRefreshing = obj => obj && obj.status === StateStatus.REFRESHING;

const stateIsLoaded = obj => {
  if (Array.isArray(obj)) {
    return obj.some(x => x.status === StateStatus.LOADED);
  }
  return obj && obj.status === StateStatus.LOADED;
};

const stateError = obj => {
  if (Array.isArray(obj)) {
    return obj.some(x => x.status === StateStatus.ERROR);
  }
  return obj && obj.status === StateStatus.ERROR;
};

export { stateError, stateHasItems, stateIsEmpty, stateIsLoaded, stateIsLoading, stateIsNotInitialized, stateIsNotReady, stateIsRefreshing };
